import { render } from "./ManageTaskUsersModal.vue?vue&type=template&id=6ef0126b"
import script from "./ManageTaskUsersModal.vue?vue&type=script&lang=js"
export * from "./ManageTaskUsersModal.vue?vue&type=script&lang=js"

import "./ManageTaskUsersModal.vue?vue&type=style&index=0&id=6ef0126b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__